import { render, staticRenderFns } from "./Echarts.vue?vue&type=template&id=be4e2a54&"
import script from "./Echarts.vue?vue&type=script&lang=js&"
export * from "./Echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports